import { DepositTypeCreateModal, DepositTypeDeleteModal } from "modules/finances/features";
import React, { CSSProperties } from "react";
import { api, DepositTypeDto } from "shared/api";
import { Modals } from "shared/lib";
import { Button, Fieldset, Icons, Menu, MenuButton, MenuContainer, MenuItem, Table } from "shared/ui";

export interface IDepositTypesForm {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const DepositTypesForm = (props: IDepositTypesForm) => {
  const depositTypeList = api.depositType.useDepositTypeList(props.companySlug);

  const onCreate = () => {
    Modals.open(DepositTypeCreateModal, { companySlug: props.companySlug });
  };

  const onDelete = (data: DepositTypeDto) => {
    Modals.open(DepositTypeDeleteModal, { data, companySlug: props.companySlug });
  };

  return (
    <Fieldset className={props.className} style={props.style} htmlId={props.htmlId}>
      <Fieldset.Content>
        <Fieldset.Title>Внедоходные источники средств</Fieldset.Title>
        <Fieldset.Subtitle>
          При зачислении денег напрямую в фонд нужно указать, откуда пришли деньги. В этой секции укажите список всех
          возможных источников внедоходных поступлений.
        </Fieldset.Subtitle>

        <Table
          type="plain"
          columns={[
            { header: "", accessor: "name" },
            { header: "", accessor: "actions", align: "right" },
          ]}
          data={depositTypeList.data?.map((it) => ({
            id: it.id,
            name: it.name,
            actions: (
              <MenuContainer>
                <MenuButton svgOnly size="small" variant="ghost" style={{ marginLeft: "auto" }}>
                  <Icons.DotsVertical />
                </MenuButton>
                <Menu minWidth={150}>
                  <MenuItem type="error" onClick={() => onDelete(it)}>
                    Удалить
                  </MenuItem>
                </Menu>
              </MenuContainer>
            ),
          }))}
          header={false}
        />
      </Fieldset.Content>
      <Fieldset.Footer>
        <Fieldset.Footer.Status></Fieldset.Footer.Status>
        <Fieldset.Footer.Actions>
          <Button size="small" onClick={onCreate}>
            Добавить
          </Button>
        </Fieldset.Footer.Actions>
      </Fieldset.Footer>
    </Fieldset>
  );
};

DepositTypesForm.defaultProps = {};
